import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { AppThunk } from './store'
import { IAppFeatureConfigs } from './models/app_models'
import { getAppFeatureConfigs } from './api/app_api'

export interface AppState {
  loading: boolean,
  appFeatureConfigs: IAppFeatureConfigs | null
}

const initialState: AppState = {
    loading: false,
    appFeatureConfigs: null
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading:  (state, action: PayloadAction<boolean>) => {
        state.loading = action.payload
    },
    setAppFeatureConfigs: (state, action: PayloadAction<IAppFeatureConfigs>) => {
      state.appFeatureConfigs = action.payload
    }
  },
})

export const fetchAppFeatureConfigs = (): AppThunk => async (dispatch) => {
  dispatch(setLoading(true))
  try{
    const profile = new URLSearchParams(window.location.search).get("profile")
    const featureConfigs = (await getAppFeatureConfigs(profile)).data
    dispatch(setAppFeatureConfigs(featureConfigs))
  } catch(e) {
    console.error(e)
  } finally {
    dispatch(setLoading(false))
  }
}

export const { 
    setLoading,
    setAppFeatureConfigs
} = appSlice.actions

export const sliceActions = appSlice.actions

export default appSlice.reducer